import { openModal } from '@core/components/ModalStack';
import { ViewProviderBillModalProps } from './ViewProviderBillModal';

export async function openViewProviderBillModal(props: ViewProviderBillModalProps) {
  const { ViewProviderBillModal } = await import('./ViewProviderBillModal');

  openModal(ViewProviderBillModal, props);
}